import { render, staticRenderFns } from "./WarningInfo.vue?vue&type=template&id=2124350c&scoped=true&"
import script from "./WarningInfo.vue?vue&type=script&lang=js&"
export * from "./WarningInfo.vue?vue&type=script&lang=js&"
import style0 from "./WarningInfo.vue?vue&type=style&index=0&id=2124350c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2124350c",
  null
  
)

export default component.exports